(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fwx-breadcrumbs"] && !Shopify.designMode) return;
  try {
    
(function () {
  var KEY = 'fwx_bc';
  var MAX_CRUMBS = 4;

  function init() {
    var nav = document.querySelector('.fwx-bc');
    if (!nav) return;

    var title = nav.getAttribute('data-title') || '';
    var path = nav.getAttribute('data-path') || window.location.pathname;
    var isDepartment = nav.getAttribute('data-is-department') === 'true';
    var list = nav.querySelector('.fwx-bc__list');
    var ROOT = { label: 'Shop by Department', url: '/collections' };

    var trail = [];
    try { trail = JSON.parse(sessionStorage.getItem(KEY) || '[]'); } catch(e) {}

    // Option 4: Reset trail when landing on a department page
    if (isDepartment) {
      trail = [ROOT, { label: title, url: path }];
    } else if (path === '/collections') {
      trail = [ROOT];
    } else {
      // Ensure root is always first
      if (!trail.length || trail[0].url !== '/collections') {
        trail.unshift(ROOT);
      }

      // Check if current page already exists in trail
      var idx = -1;
      for (var i = 0; i < trail.length; i++) {
        if (trail[i].url === path) { idx = i; break; }
      }

      if (idx !== -1) {
        // Trim back to this point
        trail = trail.slice(0, idx + 1);
        if (title) trail[idx].label = title;
      } else {
        if (title) trail.push({ label: title, url: path });
      }

      // Option 1: Enforce max 4 crumbs
      // Always keep first (root) and last (current), trim oldest middle crumbs
      if (trail.length > MAX_CRUMBS) {
        var first = trail[0];
        var last = trail[trail.length - 1];
        var middle = trail.slice(1, trail.length - 1);
        // Keep only the last (MAX_CRUMBS - 2) middle crumbs
        middle = middle.slice(middle.length - (MAX_CRUMBS - 2));
        trail = [first].concat(middle).concat([last]);
      }
    }

    // Save
    try { sessionStorage.setItem(KEY, JSON.stringify(trail)); } catch(e) {}

    // Render
    list.innerHTML = '';
    trail.forEach(function (crumb, i) {
      var li = document.createElement('li');
      li.className = 'fwx-bc__item';
      var isLast = i === trail.length - 1;
      if (isLast) {
        var span = document.createElement('span');
        span.className = 'fwx-bc__current';
        span.textContent = crumb.label;
        li.appendChild(span);
      } else {
        var a = document.createElement('a');
        a.className = 'fwx-bc__link';
        a.href = crumb.url;
        a.textContent = crumb.label;
        a.addEventListener('click', function () {
          try {
            sessionStorage.setItem(KEY, JSON.stringify(trail.slice(0, i + 1)));
          } catch(e) {}
        });
        li.appendChild(a);
      }
      list.appendChild(li);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
